import { render } from "./SegmentationBlockAND.vue?vue&type=template&id=c0298d0e&scoped=true"
import script from "./SegmentationBlockAND.vue?vue&type=script&lang=ts"
export * from "./SegmentationBlockAND.vue?vue&type=script&lang=ts"

import "./SegmentationBlockAND.vue?vue&type=style&index=0&id=c0298d0e&lang=scss&scoped=true"
import "./SegmentationBlockAND.vue?vue&type=style&index=1&id=c0298d0e&lang=scss"
script.render = render
script.__scopeId = "data-v-c0298d0e"

export default script